export enum CreativeTagTracking {
  Init = 'Init',
  Request = 'Request',
  Load = 'Load',
  Installed = 'Installed',
  Display = 'Display',
  View = 'View',
  Timespent = 'timespent',
  Show = 'Show',
  Click = 'Click',
  Fail = 'Fail',
  Engagement = 'Engagement',
  DirectionClick = 'direction_click',
  Interaction = 'interaction',
  MapActivation = 'map_activation',
  PinClick = 'pin_click',
  Reach = 'Reach',
  Complete = 'Complete',
  ChapterViewed = 'chapter_viewed',
  NavigationSlide = 'navigation_slide',
  NavigationSiteScroller = 'navigation_site_scroller',
  Redirection = 'redirection',
  RenderingError = 'rendering_error',

  VideoStart = 'start',
  VideoFirstQuartile = 'firstquartile',
  VideoMidpoint = 'midpoint',
  VideoThirdQuartile = 'thirdquartile',
  VideoComplete = 'complete',
  VideoMute = 'mute',
  VideoUnmute = 'unmute'
}
